module.exports = __webpack_public_path__ + "img/amazon.0fa6d287.png";